import { apiGet, apiPost, apiPut } from './apiClient';
import { MembershipPlanDto, MembershipPlanVersionDto } from '../Types/MembershipPlanTypes';

export const MembershipPlanService = {
  getPublic: async () => apiGet<MembershipPlanDto[]>('/api/membership-plans'),
  getAdmin: async () => apiGet<MembershipPlanDto[]>('/api/membership-plans/admin'),
  getVersions: async (id: string) => apiGet<MembershipPlanVersionDto[]>(`/api/membership-plans/${id}/versions`),
  create: async (dto: Partial<MembershipPlanDto> & { key: string; title: string; description: string; monthlyPrice: number }) =>
    apiPost<MembershipPlanDto>('/api/membership-plans', dto),
  update: async (id: string, dto: Partial<MembershipPlanDto>) =>
    apiPut<MembershipPlanDto>(`/api/membership-plans/${id}`, dto),
  syncStripe: async (id: string) =>
    apiPost<MembershipPlanDto>(`/api/membership-plans/${id}/sync-stripe`, {}),
  syncAllStripe: async () =>
    apiPost<MembershipPlanDto[]>('/api/membership-plans/sync-stripe', {}),
};
